export default __webpack_public_path__ + "static/media/TEXTLAB-LOGIN.4b41c867.svg";